import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-7',
  templateUrl: './7.component.html',
})
export class VbGeneral7Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
